import { createContext, useContext } from "react";

// PR chat pembeli: konteks terpisah dari penyedia, supaya komponen yang hanya membaca bendera tidak ikut memuat router. Bawaan = mati (WhatsApp seperti sekarang).
export const KOSONG = { aktif: false, masuk: false, teks_jam: "", belum_dibaca: 0, buka: () => {} };
export const KonteksChat = createContext(KOSONG);
export const useChat = () => useContext(KonteksChat);

export const jalurChat = (k) => {
  const q = new URLSearchParams();
  if (k && k.pesanan_id) q.set("pesanan_id", k.pesanan_id);
  else if (k && k.produk_id) q.set("produk_id", k.produk_id);
  const s = q.toString();
  return s ? `/chat?${s}` : "/chat";
};

// Ikon chat di kepala halaman (PR ikon chat): angka dari server, 0 = tanpa lencana
export const lencanaChat = (n) => { const x = Number(n) || 0; return x <= 0 ? "" : x > 99 ? "99+" : String(x); };
export const ariaChat = (n) => { const x = Number(n) || 0; return x > 0 ? `Chat, ${x} pesan belum dibaca` : "Chat"; };
